<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import MenuDesplegable from './dropsDowns/Hamburgesa/MenuDesplegable.vue'
import PanelPerfilDesplegable from './dropsDowns/perfil/PanelPerfilDesplegable.vue'
import { iniciarSesion, registro } from '@/utils/usuarioRedirections'

const props = defineProps({
  categoriasLotes: Object,
  usuarioStore: Object,
})

const isMenuHamburgerOpen = ref(false)
const isOpenPanel = ref(false)

const triggerPerfilMobile = ref(null)   
const mobileWrap = ref(null)          
const hamburgerMenuRef = ref(null)   

const userInitials = computed(() => {
  const name = props.usuarioStore.user?.name
  if (!name) return 'US'
  const parts = name.trim().split(' ').filter(Boolean)
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase()
  if (parts.length === 1 && parts[0].length >= 2) return parts[0].slice(0,2).toUpperCase()
  return (parts[0][0] + 'X').toUpperCase()
})

function toggleMenuHamburger() {
  isMenuHamburgerOpen.value = !isMenuHamburgerOpen.value
  if (isMenuHamburgerOpen.value) isOpenPanel.value = false
}

function toggleCollapsePanel() {
  isOpenPanel.value = !isOpenPanel.value
  if (isOpenPanel.value) isMenuHamburgerOpen.value = false
}

function handleClickOutside(e) {
  const trig = triggerPerfilMobile.value
  const perfilPanel = document.querySelector('.panel-perfil-desplegable')
  const hamMenu = hamburgerMenuRef.value

  const insideTrigger = trig && trig.contains(e.target)
  const insidePerfilPanel = perfilPanel && perfilPanel.contains(e.target)
  const insideHamburgerMenu = hamMenu && hamMenu.contains(e.target)

  if (!insideTrigger && !insidePerfilPanel) {
    isOpenPanel.value = false
  }

  if (isMenuHamburgerOpen.value && !insideHamburgerMenu) {
    isMenuHamburgerOpen.value = false
  }
}

onMounted(() => document.addEventListener('click', handleClickOutside))
onBeforeUnmount(() => document.removeEventListener('click', handleClickOutside))
</script>

<template>
  <header class="navbar-expand-lg shadow-none navbar-light bg-white navbar-fixed">
    <div class="barra verde bg-soft-green-oscuro" style="height: 6px; width: 100%;"></div>
    <div class="container pe-3 ps-3 p-1 pb-2">
      <div>
        <div class="hamburguesa container p-0 pt-2 p-md-2 px-md-3" ref="mobileWrap">
          <div class="d-flex justify-content-between align-items-center w-100">
            <!-- Botón Hamburguesa -->
            <button class="btn d-lg-none shadow-none ps-0" @click.stop="toggleMenuHamburger" aria-label="Abrir menú">
              <i v-if="!isMenuHamburgerOpen" class="fa fa-bars text-soft-green fs-4"></i>
              <i v-else class="fa-solid fa-xmark text-soft-green fs-4"></i>
            </button>

            <!-- Dropdown Hamburguesa -->
            <div
              ref="hamburgerMenuRef"
              class="dropdown-menu me-2 shadow border-0 mt-2 p-3 ms-3"
              :class="{ 'show': isMenuHamburgerOpen }"
              style="width: 300px; top: 55px; z-index: 1050;"
              @click.stop
            >
              <MenuDesplegable :categoriasLotes="categoriasLotes"/>
            </div>

            <div class="d-flex justify-content-center flex-grow-1">
              <a href="/" class="d-flex justify-content-center align-items-center">
                <img
                  src="@/assets/logo_sin_martillero_am.svg"
                  alt="Adrián Mercado"
                  class="img-fluid"
                  style="width: 140px;"
                />
              </a>
            </div>

            <div class="d-flex align-items-center">
              <div
                v-if="usuarioStore.user?.name != null"
                ref="triggerPerfilMobile"
                class="d-flex align-items-center"
                @click.stop="toggleCollapsePanel"
                style="cursor: pointer;"
              >
                <div
                  class="rounded-circle bg-light text-soft-green fw-bold d-flex align-items-center justify-content-center border-soft-green"
                  style="width: 44px; height: 44px;"
                >
                  {{ userInitials }}
                </div>
                <span class="fw-bold ms-2 text-capitalize fs-14 text-soft-green">
                  Hola {{ usuarioStore.user?.name?.split(' ')[0] }}
                </span>
                <i :class="isOpenPanel ? 'fa-solid fa-angle-up ms-2' : 'fa-solid fa-angle-down ms-2'"></i>
              </div>

              <div v-else class="d-flex align-items-center">
                <button class="btn btn-outline-success me-2 d-none d-sm-flex" @click="iniciarSesion()">Ingresar</button>
                <button class="btn btn-soft-green d-none d-sm-flex" @click="registro()">Registrarse</button>
                <i class="fa-regular fa-user d-flex d-sm-none fs-4 text-soft-green me-3 ms-2" @click="iniciarSesion()"></i>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-end" @click.stop>
            <PanelPerfilDesplegable :isOpenPanel="isOpenPanel" />
          </div>
        </div>
      </div>
    </div>
  </header>
</template>


<style scoped>
.navbar-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1050;
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}
</style>